import React from 'react'
import ManufacturersImage from '../components/assets/images/manufacturers.jpg';

const Manufacturers = () => {
  return (
    <div><img src={ManufacturersImage} alt='car manufacturers' style={{width:'64vw'}}/></div>
  )
}

export default Manufacturers